module.exports = require('./src/AuthErrorShower');
